import { ProgressBarInfo } from '@apply/components';
import { CUSTOM_TERM_KEY } from '../../../../../../../../../common/functions/getLoanTermOptions';
import { SetupForm, SetupLoanContext } from '../constants/setupForm';
import { isNoteDateRequired } from './isNoteDateRequired';
import { isRequiredOnceNoteDated } from './isRequiredOnceNoteDated';

/** Completion for the Setup step: only the fields that are currently required are counted. */
export const getSetupProgress = (
    form: SetupForm,
    context: SetupLoanContext,
    selectedTermKey: string
): ProgressBarInfo => {
    const fieldsComplete = [form.loanTypeId !== undefined];
    if (isNoteDateRequired(context)) {
        fieldsComplete.push(!!form.noteDate);
    }
    if (isRequiredOnceNoteDated(form)) {
        fieldsComplete.push(
            !!selectedTermKey,
            !!form.approvalDate,
            !!form.maturityDate,
            !!form.bfiNumber,
            !!form.loanNumber
        );
        if (selectedTermKey === CUSTOM_TERM_KEY) {
            fieldsComplete.push(!!form.initialTermMonths);
        }
    }
    return {
        numberComplete: fieldsComplete.filter(Boolean).length,
        total: fieldsComplete.length,
    };
};
